class CartGiftMessage extends HTMLElement {
  constructor() {
    super();
    this.lastRequestId = 0;
    this.textarea = null;
    this.statusElement = null;

    this.debouncedUpdate = this.debounce(
      this.updateGiftMessage.bind(this),
      500
    );
    this.cartChangeHandler = async (event) => {
      const cart = event.detail?.cart;
      if (cart?.item_count === 0) {
        await this.clearGiftMessageAttribute();
      }
    };
  }

  connectedCallback() {
    this.textarea = this.querySelector('#cart-gift-message');
    this.statusElement = this.querySelector('[data-status]');

    if (!this.textarea) {
      console.warn(
        '<cart-gift-message> component requires a <textarea id="cart-gift-message"> child element. ' +
          'The component will be removed.'
      );
      return this.remove();
    }

    this.textarea.addEventListener('input', () => {
      this.clearStatus();
      this.debouncedUpdate();
    });

    document.addEventListener('cart:change', this.cartChangeHandler);
  }

  disconnectedCallback() {
    document.removeEventListener('cart:change', this.cartChangeHandler);
  }

  async updateGiftMessage() {
    const value = this.textarea?.value?.trim() || '';
    if (value === '') return;

    const isValid = this.validateInput(value);
    if (!isValid) {
      this.showStatus(window.translations?.gift_message_invalid || 'Gift messages must be text-only and cannot contain emojis.', 'color-validation');
      return;
    }

    this.lastRequestId++;
    const currentRequestId = this.lastRequestId;

    const success = await this.updateCartGiftMessage(value);
    if (this.lastRequestId !== currentRequestId) return;

    if (success) {
        this.showStatus(window.translations?.gift_message_success || 'Gift message saved!', 'color-success-text');
      return;
    }

      this.showStatus(window.translations?.gift_message_error || 'There was an error saving the message.', 'color-alert-text');
  }

  async updateCartGiftMessage(value) {
    try {
      const res = await fetch(`/cart/update.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          attributes: {
            gift_message: value,
          },
        }),
        keepalive: true,
      });

      return res.ok;
    } catch {
      return false;
    }
  }

  async clearGiftMessageAttribute() {
    await this.updateCartGiftMessage('');
    if (this.textarea) this.textarea.value = '';
    this.clearStatus();
  }

  showStatus(message, type) {
    if (!this.statusElement) return;
    this.statusElement.textContent = message;
    this.statusElement.className = `gift-message-status ${type}`;
  }

  clearStatus() {
    if (
      this.statusElement &&
        (this.statusElement.textContent !== '' || this.statusElement.className !== 'gift-message-status')
    ) {
      this.statusElement.textContent = '';
      this.statusElement.className = 'gift-message-status';
    }
  }

  debounce(fn, delay) {
    let timeout;
    return function (...args) {
      clearTimeout(timeout);
      timeout = setTimeout(() => fn(...args), delay);
    };
  }

  validateInput(value) {
    const maxChars = parseInt(this.textarea?.getAttribute('maxlength')) || 180;
    const isMoreThanZero = value.length > 0;
    const isLessThanMaxChars = value.length <= maxChars;

    const emojiRegex = /\p{Emoji}/gu;

    const hasEmojis = emojiRegex.test(value);

    return isMoreThanZero && isLessThanMaxChars && !hasEmojis;
  }
}

customElements.define('cart-gift-message', CartGiftMessage);
